import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetWithDatabaseAdapts } from './tabular-type.dataset.adapter';
import { AzureSqlTableDataset } from '../../dataset/azure-sql-table.dataset';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSqlTableDataset),
    asynchronous: true,
    adapts: {
        ...tabularTypeDatasetWithDatabaseAdapts,
        properties: {
            ...tabularTypeDatasetWithDatabaseAdapts.properties,
            connectionProperties: GlobalVariables.connectionPropertiesForSql ? '*' : undefined
        }
    }
})
export class AzureSqlDatasetAdapter extends TabularTypeDatasetAdapter<AzureSqlTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureSqlTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(AzureSqlTableDataset).name,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AzureSqlTableDataset.DATABASE : undefined);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureSqlTableDataset): Promise<AzureSqlTableDataset> {
        return await this._toModelInternal(modelDatasetResource,
            dataset,
            AzureSqlTableDataset.MODEL,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AzureSqlTableDataset.DATABASE : undefined);
    }
}
